import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./weekday.js";
//#region src/weekday_helper.ts
var weekday_helper_exports = /* @__PURE__ */ __exportAll({
	allDaysStartingWithMonday: () => allDaysStartingWithMonday,
	fromIsoDayNumber: () => fromIsoDayNumber,
	name: () => name,
	toIsoDayNumber: () => toIsoDayNumber
});
function name(day) {
	switch (day) {
		case "sun": return "Sunday";
		case "mon": return "Monday";
		case "tue": return "Tuesday";
		case "wed": return "Wednesday";
		case "thu": return "Thursday";
		case "fri": return "Friday";
		case "sat": return "Saturday";
	}
}
function allDaysStartingWithMonday() {
	return [
		"mon",
		"tue",
		"wed",
		"thu",
		"fri",
		"sat",
		"sun"
	];
}
function toIsoDayNumber(day) {
	switch (day) {
		case "sun": return 0;
		case "mon": return 1;
		case "tue": return 2;
		case "wed": return 3;
		case "thu": return 4;
		case "fri": return 5;
		case "sat": return 6;
	}
}
function fromIsoDayNumber(isoDayNumber) {
	switch (isoDayNumber) {
		case 0: return "sun";
		case 1: return "mon";
		case 2: return "tue";
		case 3: return "wed";
		case 4: return "thu";
		case 5: return "fri";
		case 6: return "sat";
		default: throw new Error("Invalid ISO day number");
	}
}
//#endregion
export { allDaysStartingWithMonday, fromIsoDayNumber, name, toIsoDayNumber, weekday_helper_exports };

//# sourceMappingURL=weekday_helper.js.map